import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { HelpService } from '../../../../../commonInfra/services/HelpService';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle} from '../../../../styles/CommonStyles';
import {componentRegistryEntry} from '../../SettingsComponentRegistryFunctions';

export function BridgeSettingsSummarySection() {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsSection()}
                     testId={'bridge-settings-summary-section'}
                     description={renderDescription()}/>
  );
}

function renderDescription() {
    return <>
      <span data-tb-test-id='bridge-settings-summary'>{Messages.siteRemoteAgentSettingsDescription_v2()}</span>
      <TextLinkWidget testId={'bridge-settings-summary-learn-more'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('bridge-live-query')}
                      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
      </TextLinkWidget>
      </>;
}

/* for registering the component in settings registry */
export const BridgeSettingsSummarySectionSpecs = componentRegistryEntry({
  name: 'BridgeSettingsSummarySection',
  component: BridgeSettingsSummarySection
});
